/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getInstrumentCapabilityConfig} from '../api'

 export const useQueryGetInstrumentCapabilityConfig = createReactQueryHook('getInstrumentCapabilityConfig', getInstrumentCapabilityConfig)
